export default ({ moment }) => {
  return {
    getAllNotes(monitor) {
      return [
        ...monitor.notes,
        ...monitor.website.notes.map(note => {
          return {
            ...note,
            from: 'website'
          }
        }),
        ...monitor.tags.map(tag => tag.notes.map(note => {
          return {
            ...note,
            from: 'tag',
          }
        })).flat()
      ]
    },
    getDayNotes (monitor, date) {
      return this.getAllNotes(monitor).filter(note => {
        return moment(note.at).isSame(date, 'day')
      })
    },
    getAgeInDays(monitor) {
      return moment().diff(monitor.created_at, 'days')
    },
  }
}